'use client'

import Home from '@/page'

export default function CitiesBasePage() {
  return <Home />
} 